import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import PropTypes from "prop-types";
import { setError } from "@/features/auth/authSlice";
import { useState } from "react";

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--grey-light)",
    },
    "&:hover fieldset": {
      borderColor: "var(--primary-main)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-main)",
    },
  },
});

//SHEP-410: custom textfield error validation props
const ShepFormField = ({ error, onBlur, helperText, ...rest }) => {
  const [touched, setTouched] = useState(false);
  return (
    <div>
      <CustomTextField
        {...rest}
        // onBlur={(e) => {
        //   setTouched(true);
        //   if (onBlur) onBlur(e);
        // }}
        error={/*touched &&*/ !!error}
        helperText={/*touched && */ error ? helperText : ""}
      ></CustomTextField>
    </div>
  );
};

ShepFormField.propTypes = {
  error: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default ShepFormField;
